import React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import CustomStepIcon from "./CustomStepIcon";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.grey[300],
        borderRadius: 1,
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        backgroundColor: "#FFB347", // active connector
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        backgroundColor: "#FFB347", // completed connector
    },
}));

function ReportStepper({ steps, activeStep }) {
    return (
        <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<CustomConnector />}
            sx={{
                mb: 0,
                backgroundColor: "transparent",
                boxShadow: "none",
                paddingBottom: 1,
                paddingTop: 2,
            }}
        >
            {steps.map((label, index) => (
                <Step key={label} completed={index < activeStep}>
                    <StepLabel
                        StepIconComponent={CustomStepIcon}
                        sx={{
                            '& .MuiStepLabel-label': {
                                color: (theme) => theme.palette.grey[700], // default label color
                            },
                            '& .MuiStepLabel-label.Mui-active': {
                                color: (theme) => theme.palette.info.main, // active step label color
                            },
                            '& .MuiStepLabel-label.Mui-completed': {
                                color: (theme) => theme.palette.success.main, // completed step label color
                            },
                        }}
                    >
                        {label}
                    </StepLabel>

                </Step>
            ))}
        </Stepper>
    );
}


export default ReportStepper;
